import { render, staticRenderFns } from "./smallBagShip.vue?vue&type=template&id=5644fd99&"
import script from "./smallBagShip.vue?vue&type=script&lang=js&"
export * from "./smallBagShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports